import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=2ffdac92&scoped=true"
import script from "./PDFPreview.vue?vue&type=script&lang=js"
export * from "./PDFPreview.vue?vue&type=script&lang=js"
import style0 from "./PDFPreview.vue?vue&type=style&index=0&id=2ffdac92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffdac92",
  null
  
)

export default component.exports